// @flow

import React, { Component }      from 'react';
import { connect }               from 'react-redux';
import { getTranslate }          from 'react-localize-redux';

class CaughtApp extends Component {

  constructor() {
    super();

    this._renderText = this._renderText.bind(this);
  }

  _renderFullText() {
    const { translate } = this.props;

    return (
      <div className="col-xs-12 caught--content">
        <div className="text-cont">
          <div className="caught--text-orange">
            {translate('applications.need_review')}
          </div>
        </div>
        <div className="text-cont">
          <div className="caught--text-italic">
            {translate('applications.will_notify_you')}
          </div>
        </div>
        <div className="text-cont">
          <div className="caught--text-italic">
            {translate('applications.ussualy_notify')}
          </div>
        </div>
        <div className="caught--image-box">
          <img src='images/searchingwow.png' alt="Nick" />
        </div>
      </div>
    );
  }

  _renderShortText() {
    const { translate } = this.props;

    return (
      <div className="col-xs-12 caught--content">
        <div className="text-cont">
          <div className="caught--text-orange caught--no-bold">
            {translate('applications.no_progress')}
          </div>
        </div>
        <div className="caught--image-box">
          <img src='images/searchingwow.png' alt="Nick" />
        </div>
      </div>
    );
  }

  _renderText = () => {
    const { currentApp } = this.props;
    return currentApp.validation_message.value !== "Application was flagged by security filter" ? this._renderShortText() : this._renderFullText();
  }

  render() {
    return (
      <div id="caught" className="caught container-fluid">
        <div className="caught-rotate">
          <ul className="icons">
            <li className="active"><i className="ico ico-4"></i></li>
          </ul>
        </div>
        <div className="row">
          <div className="col-xs-0" />
          {this._renderText()}
          <div className="col-xs-0" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentApp: state.application.activeApplication,
});

export default connect(mapStateToProps)(CaughtApp);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/caughtApp.js